import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'
import Limited from '@/containers/Limited'

// Views
import PresenceManagement from '@/views/PresenceManagement'
import RecurringJobs from '@/views/RecurringJobs'
import JobLog from '@/views/JobLog'
import Login from '@/views/Login'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
    path: '/',
    redirect: '/recurring',
    name: 'Welcome',
    component: Limited,
    children: [{
      path: 'login',
      name: 'Login',
      component: Login,
      meta: { auth: false }
    }]
  }, {
    path: '/',
    redirect: '/recurring',
    name: 'Home',
    component: Full,
    children: [{
      path: 'recurring',
      name: 'Recurring Jobs',
      component: RecurringJobs,
      children: [{
        path: ':jobId',
        name: 'Job Log',
        component: JobLog
      }]
    }, {
      path: 'presence-management',
      name: 'Presence Management',
      component: PresenceManagement,
      children: [{
        path: ':jobId',
        name: 'Job Report',
        component: JobLog
      }]
    }]
  }]
})

router.onReady(() => {
  router.app.$log.debug('Router ready')

  router.app.$auth.onChange((authenticated) => {
    if (!authenticated) {
      router.push({ name: 'Login' })
    }
  })
})

router.beforeEach((to, from, next) => {
  if (router.app.$auth.signedIn() || (to.meta && to.meta.auth === false)) {
    router.app.$log.debug(to.path, 'authorized')
    next()
  } else {
    router.app.$log.debug(to.path, 'not authorized')
    next({
      path: '/login'
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js